__turbopack_context__.v({
  "container": "f1FM9G_container",
  "floatingHeader": "f1FM9G_floatingHeader",
  "footerContainer": "f1FM9G_footerContainer",
  "show": "f1FM9G_show",
  "topContainer": "f1FM9G_topContainer",
  "upsellListing": "f1FM9G_upsellListing",
});
